// extracted by mini-css-extract-plugin
export default {"cardContent":"home_cardContent__himXz","cardIcon":"home_cardIcon__I6Kp3","cardTitle":"home_cardTitle__HquHL"};